"use client";
import React from "react";
var useOnClickOutside = function (ref, handler) {
    React.useEffect(function () {
        if (!handler)
            return;
        var handleClick = function (event) {
            var refs = Array.isArray(ref) ? ref : [ref];
            var isInside = false;
            refs.forEach(function (elRef) {
                if (!elRef.current ||
                    elRef.current === event.target ||
                    elRef.current.contains(event.target)) {
                    isInside = true;
                }
            });
            if (isInside)
                return;
            handler(event);
        };
        document.addEventListener("click", handleClick, true);
        return function () { return document.removeEventListener("click", handleClick, true); };
    }, [ref, handler]);
};
export default useOnClickOutside;
